type LogoSize = 'xs' | 'sm' | 'md' | 'lg';

const sizePx: Record<LogoSize, number> = { xs: 24, sm: 30, md: 38, lg: 48 };
const textCls: Record<LogoSize, string> = {
  xs: 'text-xs',
  sm: 'text-sm',
  md: 'text-lg',
  lg: 'text-2xl',
};

export function BrandLogo({
  size = 'sm',
  inverted = false,
  showTagline = false,
}: {
  size?: LogoSize;
  inverted?: boolean;
  showTagline?: boolean;
}) {
  const s = sizePx[size];
  const wordColor = inverted ? 'text-white' : 'text-brand';

  return (
    <div className="flex items-center gap-2 shrink-0">
      <svg width={s} height={s} viewBox="0 0 36 36" fill="none" aria-hidden>
        <rect width="36" height="36" rx="8" fill="#0D7377" />
        <path d="M8 18h15" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
        <path
          d="M17 13l6 5-6 5"
          stroke="white"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="27.5" cy="10.5" r="4.5" fill="#F4A261" />
        <path d="M27.5 8.5v4M25.5 10.5h4" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
      <div className="flex flex-col leading-none">
        <span className={`${textCls[size]} font-bold tracking-tight ${wordColor}`}>InCashFlow</span>
        {showTagline && (
          <span className="text-[11px] text-gray-400 mt-0.5">Flow of commerce, clarity of stock</span>
        )}
      </div>
    </div>
  );
}
